exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-menu-right[data-v-8d16bd2c] {\n    top: auto !important;\n    left: auto !important;\n    right: 0 !important;\n    transform: none !important;\n}\n", ""]);

// exports
